import React, { useState } from "react";
import classNames from "classnames";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import CustomSnackbar from "../components/custom_snackbar";
import { REACT_APP_NAME } from "../const/sysytem";
import { CUSTOMER_INFO } from "../const/mount_list";
import { authentication } from "../services/api";

const useStyles = makeStyles(theme => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white
    }
  },
  paper: {
    marginTop: theme.spacing(8),
    textAlign: "center"
  },
  centerItem: {
    margin: "0 auto"
  },
  avatar: {
    width: "30%",
    height: "auto"
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  }
}));

function SignIn(props) {
  const classes = useStyles();
  const [error, setError] = useState("");
  const [id, setId] = useState("");
  const [password, setPassword] = useState("");
  const { setMountTarget, setAccountName, updateParent, setAccountId } = props;

  const handleSignIn = () => {
    if (
      /^([a-zA-Z0-9]{0,7})$/.test(id) ||
      /^([a-zA-Z0-9]{0,7})$/.test(password)
    )
      return setError(
        "ログインアカウントは英数8桁、ログインパスワードは英数8桁以上16桁未満で入力してください。"
      );

    authentication(id, password).done(json => {
      if (json.error_code) {
        return setError("アカウントまたはパスワードが正しくありません。");
      }
      setMountTarget(CUSTOMER_INFO);
      setAccountName(json.operator_name);
      setAccountId(id);
      updateParent("logined");
    });
  };

  const onSnackbarClose = () => {
    setError("");
  };

  const handleChangeId = event => {
    if (/^([a-zA-Z0-9]{0,8})$/.test(event.target.value))
      setId(event.target.value);
  };
  const handleChangePassword = event => {
    if (/^([a-zA-Z0-9]{0,15})$/.test(event.target.value))
      setPassword(event.target.value);
  };

  const classeee = classNames(classes.centerItem, classes.avatar);
  return (
    <>
      <div class="row">
        <div class="col-xs-3" />
        <div class="col-xs-6">
          <div className={classes.paper}>
            <Avatar className={classeee}>
              <img src="./top_icon.png" height="100%" width="100%" alt="top" />
            </Avatar>
            <p>{REACT_APP_NAME}</p>
            <p>ログイン画面</p>
            <form className={classes.form} noValidate>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="id"
                label="アカウント (英数8桁)"
                name="id"
                value={id}
                onChange={handleChangeId}
                autoComplete="id"
                autoFocus
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="パスワード (英数8桁以上15桁以下)"
                type="password"
                id="password"
                value={password}
                onChange={handleChangePassword}
              />
              <Button
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={handleSignIn}
              >
                ログイン
              </Button>
            </form>

            <CustomSnackbar
              snackMessage={error}
              onSnackbarClose={onSnackbarClose}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default SignIn;
